import { defineAsyncComponent } from 'vue';

const summaryEstimateRevenueBudgetDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateRevenueBudgetDetail.vue'),
);
const summaryEstimateRegularDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateRegularDetail.vue'),
);

const submitSummaryRegularDetailSTC = defineAsyncComponent(() =>
  import('@/views/submit/summary/SubmitSummaryRegularDetailSTC.vue'),
);


const SubmitSummaryNotifyPopup = defineAsyncComponent(() =>
  import('@/views/submit/summary/SubmitSummaryNotifyPopup.vue'),
);


const submitSummaryProjectDetailSTC = defineAsyncComponent(() =>
  import('@/views/submit/summary/SubmitSummaryProjectDetailSTC.vue'),
);



const summaryEstimateRegularDetailSTC = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateRegularDetailSTC.vue'),
);

const summaryEstimateFeesDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateFeesDetail.vue'),
);

const summaryEstimateCalculateBasisDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateCalculateBasisDetail.vue'),
);

const summaryEstimateInvestDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateInvestDetail.vue'),
);

const summaryEstimateRevenueOtherDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateRevenueOtherDetail.vue'),
);

const summaryEstimateOtherDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateOtherDetail.vue'),
);

const summaryEstimateProjectDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateProjectExpenseDetail.vue'),
);

const summaryEstimateProjectDetailSTC = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateProjectExpenseDetailSTC.vue'),
);



const summaryEstimateBusinessDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/SummaryEstimateBusinessDetail.vue'),
);

const summaryExplanationDetailPopup = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryExplanationDetailPopup.vue'),
);

const summarySalaryExplanationDetailPopup = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummarySalaryExplanationDetailPopup.vue')
);

const summaryEstArrgrateRevenueBudgetPopup = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/STC/SummaryEstArgrateRevenueBudgetDetail.vue')
);

const summaryEstArrgrateRevenueOtherPopup = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/details/STC/SummaryEstArgrateRevenueOtherDetail.vue')
);

const submitSummarySalaryExplanationDetailPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/SubmitSummarySalaryExplanationDetailPopup.vue')
);

const submitSummaryExplanationDetailPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/SubmitSummaryExplanationDetailPopup.vue')
);



const estimateSubmitQLNSDetailPopup = defineAsyncComponent(() => import('@/views/summaryEstimate/summaryBeginYear/popup/EstimateSubmitQLNSDetailPopup.vue'));

const summaryEstimateCalculateBasisSTCDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/tabs/summaryBeginYearEstimateSTC/details/SummaryEstimateCalculateBasisSTCDetail.vue')
);

const summaryEstimateInvestCapitalSTCDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/tabs/summaryBeginYearEstimateSTC/details/SummaryEstimateInvestCapitalSTCDetail.vue')
);

const summaryEstimateInvestSTCDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/tabs/summaryBeginYearEstimateSTC/details/SummaryEstimateInvestSTCDetail.vue')
);

const summaryEstimateOtherSTCDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/tabs/summaryBeginYearEstimateSTC/details/SummaryEstimateOtherSTCDetail.vue')
);

const summaryEstimateProjectExpenseSTCDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/tabs/summaryBeginYearEstimateSTC/details/SummaryEstimateProjectExpenseSTCDetail.vue')
);

const summaryEstimateRegularSTCDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/tabs/summaryBeginYearEstimateSTC/details/SummaryEstimateRegularSTCDetail.vue')
);

export function registerSummaryEstimate(app) {
  app.component('SummaryEstimateRevenueBudgetDetail', summaryEstimateRevenueBudgetDetail);
  app.component('SummaryEstimateRevenueOtherDetail', summaryEstimateRevenueOtherDetail);
  app.component('SummaryEstimateRegularDetail', summaryEstimateRegularDetail);
  app.component('SubmitSummaryRegularDetailSTC', submitSummaryRegularDetailSTC);
  app.component('SubmitSummaryProjectDetailSTC', submitSummaryProjectDetailSTC);
  app.component('SummaryEstimateRegularDetailSTC', summaryEstimateRegularDetailSTC);
  app.component('SummaryEstimateFeesDetail', summaryEstimateFeesDetail);
  app.component('SummaryEstimateCalculateBasisDetail', summaryEstimateCalculateBasisDetail);
  app.component('SummaryEstimateInvestDetail', summaryEstimateInvestDetail);
  app.component('SummaryEstimateProjectExpenseDetail', summaryEstimateProjectDetail);
  app.component('SummaryEstimateProjectExpenseDetailSTC', summaryEstimateProjectDetailSTC);
  app.component('SummaryEstimateOtherDetail', summaryEstimateOtherDetail);
  app.component('SummaryEstimateBusinessDetail', summaryEstimateBusinessDetail);
  app.component('SummaryExplanationDetailPopup', summaryExplanationDetailPopup);
  app.component('summarySalaryExplanationDetailPopup', summarySalaryExplanationDetailPopup);
  app.component('SubmitSummarySalaryExplanationDetailPopup', submitSummarySalaryExplanationDetailPopup);
  app.component('SubmitSummaryExplanationDetailPopup', submitSummaryExplanationDetailPopup);
  app.component('estimateSubmitQLNSDetailPopup', estimateSubmitQLNSDetailPopup);
  app.component('summaryEstArrgrateRevenueBudgetPopup', summaryEstArrgrateRevenueBudgetPopup);
  app.component('summaryEstArrgrateRevenueOtherPopup', summaryEstArrgrateRevenueOtherPopup);
  app.component('SummaryEstimateCalculateBasisSTCDetail', summaryEstimateCalculateBasisSTCDetail);
  app.component('SummaryEstimateInvestCapitalSTCDetail', summaryEstimateInvestCapitalSTCDetail);
  app.component('SummaryEstimateInvestSTCDetail', summaryEstimateInvestSTCDetail);
  app.component('SummaryEstimateOtherSTCDetail', summaryEstimateOtherSTCDetail);
  app.component('SummaryEstimateProjectExpenseSTCDetail', summaryEstimateProjectExpenseSTCDetail);
  app.component('SummaryEstimateRegularSTCDetail', summaryEstimateRegularSTCDetail);
  app.component('SubmitSummaryNotifyPopup', SubmitSummaryNotifyPopup);
}
